export const createSearch = (): URLSearchParams => {
  return new URLSearchParams(location.search)
}
